var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "237px",
    height: "237px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(81,50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.9519230769230769s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.9519230769230769s"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.93882858127643,51.946506105408716)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(3.6000000000000005)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.99
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.9423076923076923s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.9423076923076923s"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.75555574074882,53.88533024049343)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(7.200000000000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.98
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.9326923076923077s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.9326923076923077s"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.45090477258935,55.80882075215746)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(10.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.97
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.9230769230769231s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.9230769230769231s"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.02607799498756,57.7093865021105)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(14.400000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.96
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.9134615384615384s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.9134615384615384s"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.48275200514976,59.57952682562337)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(18)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.95
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.9038461538461539s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.9038461538461539s"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.8230710625358,61.41186113322502)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(21.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.94
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8942307692307693s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8942307692307693s"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.04963862644661,63.199158038517254)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(25.200000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.93
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8846153846153846s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8846153846153846s"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.16550708135978,64.93436389715318)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(28.800000000000004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.92
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.875s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.875s"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.17416569056246,66.6106306443489)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(32.400000000000006)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.91
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8653846153846154s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8653846153846154s"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.07952682562338,68.22134282106667)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(36)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.9
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8557692307692307s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8557692307692307s"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.88591052604947,69.76014368220937)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(39.599999999999994)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.89
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8461538461538461s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8461538461538461s"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.59802745006375,71.22096028378934)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(43.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.88
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8365384615384616s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8365384615384616s"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.22096028378934,72.59802745006375)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(46.800000000000004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.87
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8269230769230769s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8269230769230769s"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.76014368220939,73.88591052604947)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(50.400000000000006)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.86
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8173076923076923s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8173076923076923s"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.22134282106667,75.07952682562336)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(54)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8076923076923077s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8076923076923077s"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.6106306443489,76.17416569056246)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(57.60000000000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.84
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.7980769230769231s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.7980769230769231s"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.93436389715318,77.16550708135978)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(61.20000000000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.83
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.7884615384615384s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.7884615384615384s"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.199158038517254,78.04963862644661)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(64.80000000000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.82
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.7788461538461539s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.7788461538461539s"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.41186113322502,78.82307106253579)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(68.39999999999999)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.81
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.7692307692307693s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.7692307692307693s"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.579526825623375,79.48275200514976)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.7596153846153846s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.7596153846153846s"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.7093865021105,80.02607799498756)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(75.60000000000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.79
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.75s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.75s"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.808820752157466,80.45090477258935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(79.19999999999999)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.78
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.7403846153846154s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.7403846153846154s"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.88533024049344,80.7555557407488)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.77
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.7307692307692307s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.7307692307692307s"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.946506105408716,80.93882858127643)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(86.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.76
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.7211538461538461s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.7211538461538461s"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50,81)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.75
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.7115384615384616s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.7115384615384616s"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.053493894591284,80.93882858127643)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(93.60000000000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.74
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.7019230769230769s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.7019230769230769s"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.11466975950657,80.75555574074882)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(97.19999999999999)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.73
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6923076923076923s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6923076923076923s"
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.19117924784254,80.45090477258935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(100.80000000000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.72
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6826923076923077s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6826923076923077s"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.2906134978895,80.02607799498756)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(104.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.71
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6730769230769231s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6730769230769231s"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.42047317437664,79.48275200514976)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(108)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.7
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6634615384615384s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6634615384615384s"
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.58813886677499,78.8230710625358)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(111.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.69
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6538461538461539s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6538461538461539s"
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.800841961482746,78.04963862644661)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(115.20000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.68
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6442307692307693s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6442307692307693s"
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.065636102846824,77.16550708135976)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(118.80000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.67
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6346153846153846s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6346153846153846s"
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.3893693556511,76.17416569056246)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(122.40000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.66
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.625s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.625s"
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.778657178933337,75.07952682562338)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(126)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.65
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6153846153846154s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6153846153846154s"
  }))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.23985631779062,73.88591052604947)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(129.60000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.64
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6057692307692307s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6057692307692307s"
  }))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.77903971621065,72.59802745006375)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(133.20000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5961538461538461s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5961538461538461s"
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.40197254993625,71.22096028378935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(136.79999999999998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.62
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5865384615384616s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5865384615384616s"
  }))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.114089473950536,69.76014368220939)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(140.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.61
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5769230769230769s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5769230769230769s"
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.92047317437663,68.22134282106667)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5673076923076923s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5673076923076923s"
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.82583430943754,66.6106306443489)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(147.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.59
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5576923076923077s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5576923076923077s"
  }))))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.83449291864023,64.93436389715318)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(151.20000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.58
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5480769230769231s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5480769230769231s"
  }))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.9503613735534,63.19915803851726)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(154.79999999999998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.57
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5384615384615384s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5384615384615384s"
  }))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.176928937464208,61.411861133225024)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(158.39999999999998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.56
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5288461538461539s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5288461538461539s"
  }))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.51724799485024,59.579526825623375)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(162)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.55
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5192307692307693s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5192307692307693s"
  }))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.97392200501244,57.70938650211051)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(165.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.54
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5096153846153846s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5096153846153846s"
  }))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.54909522741065,55.80882075215746)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(169.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.53
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5s"
  }))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.24444425925119,53.88533024049344)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(172.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.52
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.49038461538461536s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.49038461538461536s"
  }))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.061171418723582,51.94650610540872)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(176.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.51
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.4807692307692308s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.4807692307692308s"
  }))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19,50.00000000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.5
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.47115384615384615s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.47115384615384615s"
  }))))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.061171418723582,48.053493894591284)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(183.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.49
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.46153846153846156s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.46153846153846156s"
  }))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.244444259251186,46.11466975950657)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(187.20000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.48
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.4519230769230769s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.4519230769230769s"
  }))))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.549095227410653,44.191179247842534)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(190.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.47
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.4423076923076923s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.4423076923076923s"
  }))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.973922005012433,42.29061349788951)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(194.39999999999998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.46
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.4326923076923077s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.4326923076923077s"
  }))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.517247994850237,40.42047317437663)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(198.00000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.45
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.4230769230769231s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.4230769230769231s"
  }))))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.176928937464204,38.58813886677498)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(201.60000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.44
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.41346153846153844s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.41346153846153844s"
  }))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.95036137355339,36.80084196148276)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(205.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.43
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.40384615384615385s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.40384615384615385s"
  }))))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.834492918640233,35.065636102846824)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(208.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.42
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.3942307692307692s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.3942307692307692s"
  }))))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.82583430943753,33.38936935565111)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(212.39999999999998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.41
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.38461538461538464s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.38461538461538464s"
  }))))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.920473174376617,31.778657178933347)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(216)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.375s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.375s"
  }))))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.114089473950532,30.239856317790622)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(219.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.39
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.36538461538461536s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.36538461538461536s"
  }))))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.401972549936236,28.77903971621066)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(223.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.38
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.3557692307692308s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.3557692307692308s"
  }))))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.779039716210654,27.401972549936243)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(226.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.37
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.34615384615384615s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.34615384615384615s"
  }))))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.239856317790625,26.11408947395053)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(230.40000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.36
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.33653846153846156s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.33653846153846156s"
  }))))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.77865717893333,24.92047317437663)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(234)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.35
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.3269230769230769s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.3269230769230769s"
  }))))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.38936935565111,23.825834309437525)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(237.60000000000005)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.34
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.3173076923076923s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.3173076923076923s"
  }))))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.065636102846824,22.83449291864023)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(241.20000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.33
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.3076923076923077s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.3076923076923077s"
  }))))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.80084196148276,21.950361373553385)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(244.80000000000004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.32
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.2980769230769231s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.2980769230769231s"
  }))))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.58813886677499,21.176928937464204)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(248.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.31
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.28846153846153844s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.28846153846153844s"
  }))))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.420473174376625,20.51724799485024)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(252)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.27884615384615385s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.27884615384615385s"
  }))))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.29061349788951,19.973922005012433)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(255.60000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.29
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.2692307692307692s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.2692307692307692s"
  }))))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.191179247842534,19.54909522741065)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(259.20000000000005)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.28
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.25961538461538464s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.25961538461538464s"
  }))))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.114669759506555,19.24444425925119)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(262.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.27
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.25s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.25s"
  }))))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.05349389459129,19.061171418723582)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(266.40000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.26
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.2403846153846154s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.2403846153846154s"
  }))))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.99999999999999,19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.25
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.23076923076923078s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.23076923076923078s"
  }))))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.946506105408695,19.061171418723582)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(273.59999999999997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.24
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.22115384615384615s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.22115384615384615s"
  }))))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.88533024049343,19.244444259251186)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(277.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.23
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.21153846153846154s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.21153846153846154s"
  }))))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.80882075215745,19.54909522741065)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.22
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.20192307692307693s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.20192307692307693s"
  }))))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.709386502110505,19.973922005012437)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(284.40000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.21
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.19230769230769232s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.19230769230769232s"
  }))))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.57952682562336,20.517247994850237)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(288)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.2
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.18269230769230768s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.18269230769230768s"
  }))))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.411861133225,21.1769289374642)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(291.59999999999997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.19
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.17307692307692307s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.17307692307692307s"
  }))))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.199158038517226,21.95036137355338)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(295.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.18
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.16346153846153846s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.16346153846153846s"
  }))))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.93436389715319,22.834492918640237)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(298.80000000000007)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.17
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.15384615384615385s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.15384615384615385s"
  }))))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.6106306443489,23.825834309437536)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(302.40000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.16
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.14423076923076922s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.14423076923076922s"
  }))))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.22134282106666,24.920473174376625)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(306)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.15
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.1346153846153846s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.1346153846153846s"
  }))))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.76014368220936,26.11408947395052)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(309.59999999999997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.14
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.125s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.125s"
  }))))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.22096028378932,27.401972549936225)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(313.19999999999993)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.13
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.11538461538461539s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.11538461538461539s"
  }))))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.59802745006374,28.779039716210644)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(316.79999999999995)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.12
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.10576923076923077s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.10576923076923077s"
  }))))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.88591052604947,30.239856317790622)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320.40000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.11
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.09615384615384616s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.09615384615384616s"
  }))))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.07952682562336,31.778657178933326)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(324)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.08653846153846154s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.08653846153846154s"
  }))))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.17416569056246,33.38936935565109)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(327.59999999999997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.09
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.07692307692307693s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.07692307692307693s"
  }))))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.16550708135975,35.0656361028468)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(331.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.08
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.0673076923076923s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.0673076923076923s"
  }))))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.04963862644661,36.80084196148274)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(334.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.07
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.057692307692307696s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.057692307692307696s"
  }))))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.8230710625358,38.58813886677498)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(338.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.06
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.04807692307692308s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.04807692307692308s"
  }))))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.48275200514976,40.420473174376625)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(342)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.05
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.038461538461538464s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.038461538461538464s"
  }))))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.02607799498756,42.29061349788948)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(345.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.04
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.028846153846153848s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.028846153846153848s"
  }))))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.45090477258935,44.191179247842534)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(349.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.03
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.019230769230769232s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.019230769230769232s"
  }))))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.7555557407488,46.114669759506555)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(352.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.02
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.009615384615384616s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.009615384615384616s"
  }))))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.93882858127643,48.05349389459129)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(356.40000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#1d0e0b",
    fillOpacity: 0.01
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "0s",
    values: "1.97 1.97;1 1",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "0s"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreLoader);
export default __webpack_public_path__ + "static/media/preLoader.c7bf10c53ec5de794e79a74a075132a0.svg";
export { ForwardRef as ReactComponent };